import { JsonPipe, NgIf } from '@angular/common';
import { Component, inject, ViewChild } from '@angular/core';
import { ReactiveFormsModule, FormsModule, Validators, FormBuilder, FormGroup } from '@angular/forms';
import { FilterByKeyAndValuePipe } from '../../pipes/filter-by-key-and-value.pipe';
import { PluralPipe } from '../../pipes/plural.pipe';
import { AgGridListComponent } from '../ag-grid-list/ag-grid-list.component';
import { BulkUploadComponent } from '../bulk-upload/bulk-upload.component';
import { ButtonComponent } from '../button/button.component';
import { ConfirmationPopupComponent } from '../confirmation-popup/confirmation-popup.component';
import { HeaderComponent } from '../header/header.component';
import { ModalComponent } from '../modal/modal.component';
import { SearchInputComponent } from '../search-input/search-input.component';
import { SelectInputComponent } from '../select-input/select-input.component';
import { ListActionButtonsComponent } from '../list-action-buttons/list-action-buttons.component';
import { ActivatedRoute, Router } from '@angular/router';
import { DropdownService } from '../../services/dropdown.service';
import { FormService } from '../../services/form.service';
import { GlobalService } from '../../services/global.service';
import { UserService } from '../../services/user.service';
import { ValidationService } from '../../services/validation.service';
import { DropdownUploadButtonComponent } from '../dropdown-upload-button/dropdown-upload-button.component';

@Component({
  selector: 'app-student-user',
  imports: [HeaderComponent, SearchInputComponent, JsonPipe, NgIf, ButtonComponent, FilterByKeyAndValuePipe, AgGridListComponent, ConfirmationPopupComponent, ModalComponent, BulkUploadComponent, ReactiveFormsModule, PluralPipe, FormsModule, SelectInputComponent, DropdownUploadButtonComponent],
  templateUrl: './student-user.component.html',
  styleUrl: './student-user.component.css'
})
export class StudentUserComponent {
  @ViewChild('confirmation_delete_modal') confirmation_delete_modal: ConfirmationPopupComponent | undefined;
  @ViewChild('confirmation_disabled_modal') confirmation_disabled_modal: ConfirmationPopupComponent | undefined;
  @ViewChild('bulk_modal') bulk_modal: any
  @ViewChild('view_modal') view_modal: ModalComponent | undefined;
  page_name = 'User';
  params: any = {};
  selected_ids: any = {}
  items: any = [];
  fs = inject(FormService);
  show_menu = false;


  columns: any = [];

  bulk_columns = [
    // { column_name: 'Roll Number', type: 'text', return_as: 'roll_number', sample_value: '123' },
    // { column_name: 'Date of Birth', type: 'text', return_as: 'birth_date', sample_value: '01-02-2001' },
    { column_name: 'Unique ID', type: 'text', return_as: 'registration_number', sample_value: '121' },
    { column_name: 'Name', type: 'text', return_as: 'name', sample_value: 'test', skip_validation: true, regex: this.vs.new_name_pattern, min_length: this.vs.min_length_name, max_length: this.vs.max_length_name, },
    { column_name: 'Email', type: 'text', return_as: 'email', sample_value: 'Mumbai@gmail.com', skip_validation: true },
    { column_name: 'Contact', type: 'text', return_as: 'contact', sample_value: '1210100121', skip_validation: true },
    { column_name: 'Password', type: 'text', return_as: 'password', sample_value: 'Admin@123', skip_validation: true },
  ];

  bulk_columns_download: any = [];

  bulk_form: FormGroup = this.fb.group({
    university_id: ['', Validators.required],
    academic_year_id: ['', Validators.required],
  });

  filteredBulkAcademicYears: any[] = [];

  onBulkUniversityChange(event: any) {
    this.bulk_form.patchValue({ academic_year_id: '' });
    const university_id = event?.value?.value;
    if (!university_id) {
      this.filteredBulkAcademicYears = [];
      return;
    }
    const academic_year_ids = (this.ds.dropdown_list?.exam_list || [])
      .filter((e: any) => e.university_id == university_id)
      .map((e: any) => e.academic_year_id || e.AcademicYear?.id)
      .filter((id: any, i: number, self: any[]) => id && self.indexOf(id) === i);
    this.filteredBulkAcademicYears = (this.ds.dropdown_list?.academic_list || [])
      .filter((a: any) => academic_year_ids.includes(a.id));
  }

  close_bulk_modal() {
    this.bulk_form.reset({ university_id: '', academic_year_id: '' });
    this.filteredBulkAcademicYears = [];
  }

  actions(row: any) {
    let actions: any = []
    actions.push({ text: row.is_active ? 'Disable' : 'Enable', shortcut: 'u', color: 'gray', icon: row.is_active ? 'bx bx-block' : 'bx bx-check-circle', function: this.disable.bind(this), permissions: this.gs.user_role_data?.user_management_students_disable })
    actions.push({ text: 'View', shortcut: 'u', color: 'sky', icon: 'bx bx-eye', function: this.open_view_modal.bind(this), permissions: this.gs.user_role_data?.user_management_students_view })
    actions.push({ text: 'Edit', shortcut: 'u', color: 'sky', icon: 'bx bx-edit', function: this.open_form_modal.bind(this), permissions: this.gs.user_role_data?.user_management_students_update })
    // A student already mapped to an exam/script (has_mapping, from get-user-list) should not be
    // deletable — hide the option entirely rather than just disabling it, since deleting would
    // orphan the StudentMapping row (the backend also refuses this independently).
    actions.push({ text: 'Delete', shortcut: 'd', color: 'red', icon: 'bx bx-trash', function: this.delete.bind(this), permissions: this.gs.user_role_data?.user_management_students_delete && !row.has_mapping })
    return actions
  }
  constructor(public gs: GlobalService, public route: Router, public fb: FormBuilder, public us: UserService, public ar: ActivatedRoute, public ds: DropdownService, public vs: ValidationService) {
  }
  selectedRole: any = null;
  filter_params: any = {};

  onFilterChange(event: any, key: string) {
    if (event?.value) {
      this.filter_params[key] = event.value.value;
    } else {
      delete this.filter_params[key];
    }
    this.get_list({ ...this.params, ...this.filter_params });
  }

  getRowStyle = (params: any) => {
    if (params.data?.is_active === false) {
      return { background: '#F7F7F7', color: '#9ca3af' };
    }
    return null;
  };

  async ngOnInit() {
    await this.ds?.get_dropdown_list(['role', 'university', 'exam', 'subject', 'college', 'academic-year']);
    // set default role_id dynamically to the Role entry for students (if available)
    // try {
    //   const studentRole = this.ds.dropdown_list?.role_list?.find((r: any) => (r.title || '').toString().toLowerCase().includes('student'))?.value;
    //   if (studentRole) {
    //     // only set default when creating new user (i.e., no selected_ids/user present)
    //     if (!this.selected_ids || Object.keys(this.selected_ids).length === 0) {
    //       this.form.patchValue({ role_id: studentRole });
    //     }
    //   }
    // } catch (e) {
    //   // ignore if dropdowns or structure not present
    // }
    this.ar.queryParams.subscribe(params => {
      this.params = { ...params, user_type: 'student' };
      this.page_name = 'Student';
      this.column_push()
      const user_type_params = { ...this.params, user_type: 'student' };
      this.get_list(user_type_params)
    });
  }

  column_push() {
    this.columns = [
      { field: 'name', headerName: 'Name', filter: true, flex: 1, },
      { field: 'registration_number', headerName: 'Unique ID', filter: true, flex: 1, },
      {
        headerName: 'Student Details', filter: true, flex: 1,
        cellRenderer: (p: any) => {
          const contact = p.data?.contact ? `+91${p.data.contact}` : '';
          const email = p.data?.email || '';
          return `<div style="display:flex; flex-direction:column; justify-content:center; height:100%; line-height:1.4"><span style="font-weight:500; color:#1f2937; font-size:13px">${contact}</span><span style="color:#6b7280; font-size:12px">${email}</span></div>`;
        }
      },
      { field: 'is_active', headerName: 'Status', filter: true, flex: 0.7, valueGetter: (params: any) => params.data?.is_active, cellRenderer: (params: any) => { return params.value ? 'Enable' : 'Disable'; } },
      { headerName: "", sortable: false, flex: 1, cellRenderer: ListActionButtonsComponent, headerClass: 'custom-header-center', cellRendererParams: { actions: this.actions.bind(this) }, editable: false, pinned: 'right', }
    ]

    this.bulk_columns_download = [
      { column_name: 'University', download_bind: 'university_id', type: 'link', linked_list: 'university_list', linked_from: 'university', return_as: 'university_id', returning_key: 'id', sample_value: '1' },
      { column_name: 'Batch', download_bind: 'academic_year_id', type: 'link', linked_list: 'academic_list', linked_from: 'academic-year', return_as: 'academic_year_id', returning_key: 'id', sample_value: '1' },
      { column_name: 'Unique ID', type: 'text', return_as: 'registration_number', sample_value: 'AD' },
      { column_name: 'Name', type: 'text', return_as: 'name', sample_value: 'Mumbai' },
      { column_name: 'Email', type: 'text', return_as: 'email', sample_value: 'Mumbai@gmail.com' },
      { column_name: 'Contact', type: 'text', return_as: 'contact', sample_value: '123456' },
    ]
  }

  async get_list(filter?: any) {
    try {
      const finalFilter = { ...filter, user_type: 'student' };
      const res = await this.us.get_list(finalFilter);
      const page = filter?.page || 1;
      const pagesize = filter?.page_size || 10;
      const startindex = (page - 1) * pagesize;

      res.data = res.data.map((item: any, index: number) => ({
        ...item,
        SrNo: startindex + index + 1
      }));

      this.items = res;
    } catch (error: any) {
      console.error("Error fetching Booking list:", error);
      this.gs.toastr_shows_function(error?.error?.message, 'Error', 'error');
    }
  }
  async disable(item: any, index: any) {
    this.selected_ids = item;
    this.confirmation_disabled_modal?.open();
  }

  async delete(item: any, index: any) {
    this.selected_ids = item;
    this.confirmation_delete_modal?.open();
  }

  async bulk_delete(ids: any[]) {
    try {
      for (let id of ids) {
        // const user_type = 'student';
        let res = await this.us.delete(id);
      }
      this.gs.toastr_shows_function('Records deleted successfully', 'Success', 'success');
      await this.get_list(this.params);
    } catch (error: any) {
      this.gs.toastr_shows_function(error?.error?.message, 'Error', 'error');
    }
  }

  open_form_modal(item?: any) {
    if (item?.id) {
      this.route.navigate(['/user/student/form'], { queryParams: { id: item.id } });
    } else {
      this.route.navigate(['/user/student/form']);
    }
  }

  open_view_modal(item: any) {
    this.selected_ids = item || {};
    this.view_modal?.open();
  }

  async update_country(item: any) {
    try {
      let data = item == true ? false : true;
      let update = await this.us.update(this.selected_ids?.id, { is_active: data, user_type: 'student' });
      this.gs.toastr_shows_function('Status has been successfully updated', 'Success', 'success');
      this.confirmation_delete_modal?.close()
      await this.get_list(this.params);
    } catch (error: any) {
      this.gs.toastr_shows_function(error?.error?.message, 'Error', 'error');
    }
  }
  async disable_country() {
    try {
      let res = await this.us.delete(this.selected_ids?.id);
      if (res?.code === 200) {
        this.gs.toastr_shows_function(res?.message, 'Success', 'success');
      }
      this.selected_ids = {};
      this.confirmation_delete_modal?.close();
      await this.get_list(this.params);
    } catch (error: any) {
      this.gs.toastr_shows_function(error?.error?.message || 'Delete failed', 'Error', 'error');
    }
  }

  async bulk_upload(data: any, spinner: any) {
    try {
      // Get student role ID from dropdown service
      let studentRoleId = null;
      try {
        const studentRole = this.ds.dropdown_list?.role_list?.find((r: any) => (r.title || '').toString().toLowerCase().includes('student'));
        if (studentRole && studentRole.value) {
          studentRoleId = studentRole.value;
        }
      } catch (e) {
        console.warn('Could not find student role', e);
      }

      const updatedData = data.map((item: any) => ({
        ...item,
        is_active: true,
        user_type: 'student',
        ...(studentRoleId && { role_id: studentRoleId })
      }));
      console.log(updatedData);
      await this.gs.bulk_form_submission(updatedData, this.us, this.params, this.get_list.bind(this), this.bulk_modal, spinner)
    } catch (error: any) {
      console.error(error?.error?.message, '');
      this.gs.toastr_shows_function(error?.error?.message, 'Error', 'error');
    }
  }

}
